import { IconProps } from 'interfaces';
import COLOR from 'constants/color';

const Globe = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-4',
  styles
}: IconProps) => {
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
    >
      <circle
        cx='12'
        cy='12'
        r='10'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Globe;
